import { render, staticRenderFns } from "./paketrezervasyonlistesi.vue?vue&type=template&id=858a1372"
import script from "./paketrezervasyonlistesi.vue?vue&type=script&lang=js"
export * from "./paketrezervasyonlistesi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports